import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HtmlToTextPipe } from '../_pipe/htmlToText.pipe';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, private translate: TranslateService) { }

  private apiUrl = environment.apiUrl;
  private configuratoreApiUrl = environment.configuratoreApiUrl;

  superServizio(jsonIn) {
    return this.http.post(this.apiUrl + 'sito/superServizio', jsonIn).pipe(map((res: any) => res.result));
  }

  search(jsonIn) {
    return this.http.post(this.apiUrl + 'sito/search', jsonIn).pipe(map((res: any) => res.result));
  }

  schedaSearchSchede(jsonIn) {
    return this.http.post(this.apiUrl + 'scheda/search?noBlock', jsonIn).pipe(map((res: any) => res.result));
  }

  schedaSearchSchedeConBlock(jsonIn) {
    return this.http.post(this.apiUrl + 'scheda/searchSchede', jsonIn).pipe(map((res: any) => res.result));
  }

  schedaGetScheda(jsonIn) {
    return this.http.post(this.apiUrl + 'scheda/getScheda', jsonIn).pipe(map((res: any) => res.result));
  }

  getHomepage(jsonIn) {
    return this.http.post(this.apiUrl + 'homepage/getHomepage', jsonIn).pipe(map((res: any) => res.result));
  }

  getPagina(jsonIn) {
    return this.http.post(this.apiUrl + 'pagina/getPagina', jsonIn).pipe(map((res: any) => res.result));
  }


  // fornitori

  searchFornitori(jsonIn) {
    return this.http.post(this.apiUrl + 'fornitore/searchFornitori', jsonIn).pipe(map((res: any) => res.result));
  }
  getCategorieFornitori(jsonIn) {
    return this.http.post(this.apiUrl + 'fornitore/elencoCategorie', jsonIn).pipe(map((res: any) => res.result));
  }
  getsottoCategorieFornitori(jsonIn) {
    return this.http.post(this.apiUrl + 'fornitore/elencoSottocategorie', jsonIn).pipe(map((res: any) => res.result));
  }
  getScontiFornitori(jsonIn) {
    return this.http.post(this.apiUrl + 'fornitore/elencoSconti', jsonIn).pipe(map((res: any) => res.result));
  }

  // Configuratore

  strutturaConfiguratore() {
    return this.http.get(this.configuratoreApiUrl);
  }

  // Carrello

  saveCarrello(jsonIn: {language, carrello: Carrello}) {
    delete jsonIn.carrello.indirizzi;
    return this.http.post(this.apiUrl + 'carrello/saveCarrello', jsonIn).pipe(map((res: any) => res.result));
  }

  checkCoupon(jsonIn: {language, carrello: Carrello}) {
    return this.http.post(this.apiUrl + 'carrello/checkCoupon', jsonIn);
  }

  removeProdottoCarrello(jsonIn: { language, idUtente?: number, idCarrello: number, idScheda: number, idPercorso: number, idSchedaPadre}) {
    return this.http.post(this.apiUrl + 'carrello/removeProdottoCarrello', jsonIn).pipe(map((res: any) => res.result));
  }

  getCarrello(jsonIn: {idUtente?, idCarrello, language}) {
    return this.http.post(this.apiUrl + 'carrello/getCarrello', jsonIn).pipe(map((res: any) => res.result));
  }

  saveIndirizzo(jsonIn: {language, indirizzo: Indirizzo}) {
    return this.http.post(this.apiUrl + 'carrello/saveIndirizzo', jsonIn).pipe(map((res: any) => res.result));
  }

  getSpeseSpedizione(jsonIn: {cdLingua}) {
    return this.http.post(this.apiUrl + 'spedizioneSpese/getSpeseSpedizione', jsonIn).pipe(map((res: any) => res.result));
  }

  // Area Riservata

  login(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/login', jsonIn);
  }

  logout(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/logout', jsonIn).pipe(map((res: any) => res.result));
  }

  registrazione(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/registrazione', jsonIn);
  }

  confirmUserMail(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/confirmUserMail', jsonIn);
  }

  resetPassword(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/resetPassword', jsonIn);
  }

  modificaPasswordProvvisoria(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/modificaPasswordProvvisoria', jsonIn);
  }

  utenteRegistratoSaveIndirizzo(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/saveIndirizzo', jsonIn).pipe(map((res: any) => res.result));
  }

  utenteRegistratoUpdate(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/update', jsonIn);
  }

  utenteRegistratoUpdatePassword(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/updatePassword', jsonIn);
  }

  utenteRegistratoToggleNewsletter(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/toggleNewsletter', jsonIn);
  }

  deleteAccount(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/deleteAccount', jsonIn);
  }

  confirmDeleteAccount(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/confirmDeleteAccount', jsonIn);
  }

  // Ordini

  ordiniUtente(jsonIn) {
    return this.http.post(this.apiUrl + 'ordine/ordiniUtente', jsonIn).pipe(map((res: any) => res.result));
  }

  dettaglioOrdine(jsonIn) {
    return this.http.post(this.apiUrl + 'ordine/dettaglioOrdine', jsonIn).pipe(map((res: any) => res.result));
  }


  // Pagamento

  paga(jsonIn) {
    return this.http.post(this.apiUrl + 'payment/paga', jsonIn).pipe(map((res: any) => res.result));
  }

  ordinePagato(jsonIn) {
    return this.http.post(this.apiUrl + 'payment/ordinePagato', jsonIn).pipe(map((res: any) => res.result));
  }

  pagamentoAnnullato(jsonIn) {
    return this.http.post(this.apiUrl + 'payment/pagamentoAnnullato', jsonIn).pipe(map((res: any) => res.result));
  }

  pagamentoRifiutato(jsonIn) {
    return this.http.post(this.apiUrl + 'payment/pagamentoRifiutato', jsonIn).pipe(map((res: any) => res.result));
  }


  newsletter(jsonIn) {
    return this.http.post(this.apiUrl + 'sito/newsletter', jsonIn);
  }

  googleMapsPlacesSearch(query) {
    return this.http.get(`https://maps.googleapis.com/maps/api/place/findplacefromtext/json?key=${environment.googleApiKey}&inputtype=textquery&input=${query}&language=fr`);
  }

  // Conattto

  paginaContactUs(jsonIn) {
    return this.http.post(this.apiUrl + 'pagina/contactUs', jsonIn);
  }

  // Wishlist

  utenteRegistratoSavePreferito(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/savePreferito', jsonIn).pipe(map((res: any) => res.result));
  }

  utenteRegistratoDeletePreferito(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/deletePreferito', jsonIn).pipe(map((res: any) => res.result));
  }

  utenteRegistratoGetWishlist(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/getWishlist', jsonIn).pipe(map((res: any) => res.result));
  }

  utenteRegistratoShareWishlist(jsonIn) {
    return this.http.post(this.apiUrl + 'utenteRegistrato/shareWishlist', jsonIn).pipe(map((res: any) => res.result));
  }

}

export class Scheda {
  language: string;
  titolo: string;
  testo: string;
  dataDal: string;
  dataAl: string;
  categorie: [];
  sottocategorie: [];
  filtri: [];
  macrozone: [];
  zone: [];
  bwcard: boolean;
  prezzo_basso: boolean;
  prezzo_medio: boolean;
  prezzo_alto: boolean;
  idFornitore: number;
  orderBy: string;
  orderType: string;
  numRecordIniziale: number;
  numRecordDaEstrarre: number;
}

export class Carrello {
  idCarrello: number;
  idUtente: number;
  numProdotti: number;
  recuperoMagazzino: boolean;
  costoRecuperoMagazzino: number;
  corriere: boolean;
  costoCorriere: number;
  spedizioneFornitore: boolean;
  costoSpedizioneFornitore: number;
  idFornitore: number;
  installazioneAutonoma: boolean;
  installazioneFornitore: boolean;
  totaleProdotti: number;
  totaleInstallazione: number;
  totaleSpedizione: number;
  codiceCoupon: string;
  subTotale: number;
  totaleSconto: number;
  prezzoFinale: number;
  prodotti: ProdottoCarrello[] = [];
  indirizzi: Indirizzo[] = [];
  idRegioneSpedizione: number;
  costoSpedizioneRegione: number;
  descRegioneSpedizione?: string;
  prodottiDaInstallare: ProdottoCarrello[] = [];
}

export class ProdottoCarrello {
  idCarrello?: number;
  idDettaglio?: number;
  idScheda: number;
  idPercorso: number;
  idSchedaPadre?: number;
  titolo?: string;
  sku?: string;
  idAllegato?: number;
  pathFile?: string;
  quantita: number;
  totaleProdotto?: number;
  totaleInstallazione?: number;
  totaleSpedizione?: number;
  totaleSconto?: number;
  prezzoFinale?: number;
  prezzoUnitario?: number;
  prezzoPromoUnitario?: number;
  ordine?: string;
  categorie?: any[];
  sottocategorie?: Sottocategoria[];
  seo?: Seo;
  installabile?: boolean;
}

export interface Sottocategoria {
  id: number,
  nome: string,
  seo: Seo
}

export interface Seo {
  noFollow: boolean,
  slug: string,
  title: string
}

export class Indirizzo {
  dtInserimento: string;
  dtModifica: string;
  enabled: boolean;
  readOnly: boolean;
  firstUser: number;
  lastUserModified: number;
  idUtenteRegistratoIndirizzo: number;
  idUtente: number;
  idCarrello: number;
  idCarrelloIndirizzo: number;
  idTipoIndirizzo: number;
  tipoIndirizzo: string;
  nome: string;
  cognome: string;
  societa: string;
  telefono: string;
  indirizzo: string;
  civico: string;
  cap: string;
  provincia: string;
  comune: string;
  nazione: string;
  note: string;
  predefinito: boolean;
}

export class RegistrazioneRequest {
  nome: string;
  cognome: string;
  password: string;
  confirmPassword?: string;
  email: string;
  language: string;
  newsletter: boolean;
  privacy: boolean;
  consCommerciali: boolean;
  urlPaginaAttivazioneCliente: string;
  idCarrello: number;
}
